import {MayArray} from '@/types'

export const toArray = <T>(value?: MayArray<T>): T[] => {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'undefined') {
    return []
  }

  return [value]
}
